var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _line5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 100,
    viewBox: "0 0 121 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.377451,
    y: 0.377451,
    width: 120.245,
    height: 99.2451,
    rx: 3.62255,
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 0.754902
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4624 58.3468C76.3045 58.3468 75.1939 57.8867 74.3751 57.0676C73.5562 56.2486 73.096 55.1377 73.0957 53.9792C73.0954 52.8207 73.555 51.7096 74.3735 50.8901C75.192 50.0706 76.3023 49.61 77.4602 49.6094C78.6181 49.6088 79.7289 50.0684 80.5481 50.887C81.3674 51.7057 81.8282 52.8164 81.829 53.9748C81.8299 55.1333 81.3708 56.2447 80.5528 57.0645C79.7347 57.8844 78.6247 58.3457 77.4667 58.3468H77.4624Z",
    fill: "url(#paint0_radial_2307_5515)",
    stroke: "#6D8AFF",
    strokeWidth: 0.273497
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4045 22.8149C18.7062 22.8149 17.0774 22.1401 15.8764 20.9388C14.6754 19.7375 14.0004 18.1081 14 16.4091C13.9996 14.71 14.6737 13.0803 15.8741 11.8784C17.0745 10.6765 18.703 10.0009 20.4012 10C22.0995 9.99915 23.7286 10.6732 24.9303 11.8739C26.1319 13.0746 26.8076 14.7036 26.8089 16.4027C26.8102 18.1017 26.1369 19.7318 24.937 20.9343C23.7372 22.1367 22.1091 22.8132 20.4109 22.8149L20.4045 22.8149Z",
    fill: "url(#paint1_radial_2307_5515)",
    stroke: "#6D8AFF",
    strokeWidth: 0.273497
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4225 86.3055C96.3382 86.3055 94.3393 85.4773 92.8653 84.003C91.3914 82.5287 90.563 80.529 90.5625 78.4438C90.562 76.3585 91.3893 74.3585 92.8626 72.8834C94.3358 71.4084 96.3343 70.5792 98.4186 70.5781C100.503 70.5771 102.502 71.4043 103.977 72.8779C105.452 74.3514 106.281 76.3507 106.283 78.4359C106.284 80.5212 105.458 82.5217 103.985 83.9974C102.513 85.4732 100.515 86.3034 98.4304 86.3055H98.4225Z",
    fill: "url(#paint2_radial_2307_5515)",
    stroke: "#7F52C7",
    strokeWidth: 0.273497
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3777 37.3763C32.2162 37.3763 30.1433 36.5174 28.6147 34.9885C27.0861 33.4596 26.2271 31.3859 26.2266 29.2234C26.226 27.0609 27.084 24.9868 28.6118 23.4571C30.1396 21.9274 32.2121 21.0675 34.3736 21.0664C36.5351 21.0653 38.6085 21.9232 40.1378 23.4513C41.6671 24.9795 42.5272 27.0528 42.5288 29.2152C42.5304 31.3777 41.6735 33.4523 40.1464 34.9827C38.6194 36.5132 36.5473 37.3741 34.3858 37.3763L34.3777 37.3763Z",
    fill: "url(#paint3_radial_2307_5515)",
    stroke: "#6D8AFF",
    strokeWidth: 0.273497
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8692 53.9785C59.2481 53.9785 57.6934 53.3343 56.547 52.1877C55.4005 51.041 54.7563 49.4857 54.7559 47.8638C54.7555 46.242 55.3989 44.6864 56.5448 43.5391C57.6907 42.3919 59.245 41.7469 60.8661 41.7461C62.4872 41.7453 64.0423 42.3887 65.1893 43.5348C66.3363 44.6809 66.9813 46.2359 66.9825 47.8577C66.9838 49.4796 66.341 51.0355 65.1958 52.1833C64.0505 53.3312 62.4964 53.9769 60.8753 53.9785L60.8692 53.9785Z",
    fill: "url(#paint4_radial_2307_5515)",
    stroke: "#7F52C7",
    strokeWidth: 0.273497
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4226 45.5326C96.2611 45.5326 94.1882 44.6737 92.6596 43.1447C91.131 41.6158 90.272 39.5421 90.2715 37.3796C90.2709 35.2172 91.1289 33.143 92.6567 31.6133C94.1845 30.0837 96.2571 29.2237 98.4185 29.2227C100.58 29.2216 102.653 30.0794 104.183 31.6076C105.712 33.1357 106.572 35.209 106.574 37.3715C106.575 39.534 105.718 41.6085 104.191 43.139C102.664 44.6694 100.592 45.5304 98.4308 45.5326L98.4226 45.5326Z",
    fill: "url(#paint5_radial_2307_5515)",
    stroke: "#4EBEFF",
    strokeWidth: 0.273497
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6253 72.9106C23.5832 72.9106 22.5837 72.4965 21.8467 71.7593C21.1097 71.0222 20.6956 70.0223 20.6953 68.9797C20.6951 67.9371 21.1087 66.9371 21.8453 66.1995C22.582 65.462 23.5812 65.0474 24.6234 65.0469C25.6655 65.0464 26.6652 65.46 27.4025 66.1967C28.1399 66.9335 28.5545 67.9332 28.5553 68.9758C28.5561 70.0184 28.1429 71.0186 27.4067 71.7565C26.6704 72.4944 25.6714 72.9095 24.6292 72.9106H24.6253Z",
    fill: "url(#paint6_radial_2307_5515)",
    stroke: "#7F52C7",
    strokeWidth: 0.273497
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8073 28.3485C47.723 28.3485 45.7241 27.5203 44.2501 26.046C42.7761 24.5717 41.9478 22.572 41.9473 20.4868C41.9467 18.4015 42.7741 16.4014 44.2473 14.9264C45.7206 13.4514 47.7191 12.6221 49.8033 12.6211C51.8876 12.6201 53.8869 13.4473 55.3617 14.9208C56.8364 16.3944 57.6657 18.3937 57.6673 20.4789C57.6688 22.5641 56.8425 24.5646 55.37 26.0404C53.8975 27.5162 51.8994 28.3464 49.8151 28.3485L49.8073 28.3485Z",
    fill: "url(#paint7_radial_2307_5515)",
    stroke: "#6D8AFF",
    strokeWidth: 0.273497
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4224 25.434C96.4153 25.434 94.4905 24.6364 93.0711 23.2167C91.6517 21.797 90.854 19.8714 90.8535 17.8634C90.853 15.8554 91.6497 13.9294 93.0684 12.509C94.4871 11.0886 96.4116 10.2901 98.4186 10.2891C100.426 10.2881 102.351 11.0846 103.771 12.5036C105.191 13.9226 105.99 15.8478 105.991 17.8558C105.993 19.8638 105.197 21.7902 103.779 23.2114C102.361 24.6325 100.437 25.432 98.43 25.434L98.4224 25.434Z",
    fill: "url(#paint8_radial_2307_5515)",
    stroke: "#4EBEFF",
    strokeWidth: 0.273497
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8289 77.8607C79.6674 77.8607 77.5944 77.0018 76.0659 75.4729C74.5373 73.944 73.6783 71.8702 73.6777 69.7078C73.6772 67.5453 74.5352 65.4711 76.063 63.9415C77.5908 62.4118 79.6633 61.5519 81.8248 61.5508C83.9862 61.5497 86.0596 62.4076 87.589 63.9357C89.1183 65.4639 89.9784 67.5371 89.98 69.6996C89.9816 71.8621 89.1247 73.9367 87.5976 75.4671C86.0706 76.9975 83.9985 77.8585 81.837 77.8607L81.8289 77.8607Z",
    fill: "url(#paint9_radial_2307_5515)",
    stroke: "#4EBEFF",
    strokeWidth: 0.273497
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9.75,
    x2: 111,
    y2: 9.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 29.75,
    x2: 111,
    y2: 29.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 49.75,
    x2: 111,
    y2: 49.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 69.75,
    x2: 111,
    y2: 69.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 89.75,
    x2: 111,
    y2: 89.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.589 52.2306) scale(6.11334 6.11621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1236 13.8445) scale(8.96623 8.97044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.8505 75.2963) scale(11.004 11.0092)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F52C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7475 25.9594) scale(11.4116 11.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6465 45.4158) scale(8.55868 8.5627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F52C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.7924 34.1156) scale(11.4116 11.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBEFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8393 67.406) scale(5.50201 5.50459)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F52C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2353 17.3393) scale(11.004 11.0092)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.9086 14.8325) scale(10.5965 10.6014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBEFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2307_5515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.1986 66.4438) scale(11.4116 11.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChart);
export default __webpack_public_path__ + "static/media/bubble-chart.67e595e85738bd201bb93f7359be3525.svg";
export { ForwardRef as ReactComponent };